import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Play with the pattern coefficient to see its effect on the directivity pattern. Click on “play sound” and move the orange disc to listen to the effect of the different directivities.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0414/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
